import { formatDate } from '@/lib/format'
import { referralsTexts } from '../referrals.texts'
import type { ReferralUsage } from '../referrals.types'
import { UsageStatusBadge } from './UsageStatusBadge'

interface UsagesTableProps {
  usages: ReferralUsage[]
}

export const UsagesTable = ({ usages }: UsagesTableProps) => {
  const texts = referralsTexts.usages
  const cols = texts.columns

  if (usages.length === 0) {
    return <p className="text-sm text-muted">{texts.empty}</p>
  }

  return (
    <div className="overflow-x-auto rounded-md border border-border-light">
      <table className="w-full text-sm">
        <thead className="bg-background-secondary text-foreground">
          <tr>
            <th className="text-left font-medium px-4 py-3">{cols.name}</th>
            <th className="text-left font-medium px-4 py-3">{cols.email}</th>
            <th className="text-left font-medium px-4 py-3">{cols.plan}</th>
            <th className="text-left font-medium px-4 py-3">{cols.status}</th>
            <th className="text-left font-medium px-4 py-3">{cols.date}</th>
          </tr>
        </thead>
        <tbody>
          {usages.map((usage, index) => (
            <tr key={`${usage.email}-${usage.subscribedAt}-${index}`} className="border-t border-border-light">
              <td className="px-4 py-3 text-foreground whitespace-nowrap">
                {[usage.firstName, usage.lastName].filter(Boolean).join(' ') || '—'}
              </td>
              <td className="px-4 py-3 text-foreground">{usage.email}</td>
              <td className="px-4 py-3 text-foreground whitespace-nowrap">
                {/* Fallback to the raw value so an unknown plan never renders blank. */}
                {texts.plan[usage.plan] ?? usage.plan}
              </td>
              <td className="px-4 py-3">
                <UsageStatusBadge status={usage.status} />
              </td>
              <td className="px-4 py-3 text-foreground whitespace-nowrap">
                {formatDate(usage.subscribedAt)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
